export default {
    init() {
        const closeButtons = document.querySelectorAll('[data-service-close]');
        
        if(!(closeButtons)){
            return ;
        }
        for(const close of closeButtons ){
            close.addEventListener('click', (event) => {
                const target = close.parentElement;
                const optioncontainer = document.querySelector('[data-options]');
                target.classList.remove(target.classList[0] + '--active');
                if(optioncontainer){
                    optioncontainer.classList.remove(optioncontainer.classList[0] + '--active');
                }
            });
        }
    }
}